<template>
  <div class="login">
    <div class="login-more">
      <div class="justify-center align-center d-flex width-height">
        <div>
          <v-row class=" justify-center d-flex pb-5">
            <img src="@/assets/login/상단 텍스트_아이콘.svg" />
          </v-row>
          <v-row class="pt-2">
            <v-card
              :width="idCheck ? 407 : 420"
              :height="idCheck ? 407 : 480"
              class="pa-40 card"
            >
              <v-row class="color-white justify-center d-flex">
                <h3 class="color-white text-center pt-3">
                  {{ idCheck ? "아이디 찾기" : "비밀번호 찾기" }}
                </h3>
              </v-row>
              <v-row class="justify-center d-flex" v-if="windowWidth > 500">
                <h4 class="color-white pt-4  " v-html="text"></h4>
              </v-row>
              <div>
                <v-row class="pt-5 pb-3">
                  <input placeholder="이름" class="input" v-model="name" />
                </v-row>
                <v-row v-if="!idCheck" class="pb-3 ">
                  <input
                    placeholder="아이디를 입력해주세요. ex)xxx@xxx.xxx"
                    class="input"
                    v-model="id"
                  />
                </v-row>
                <v-row class="pb-5">
                  <input
                    placeholder="전화번호(공백없이 숫자만)."
                    class="input"
                    v-model="phoneNumber"
                  />
                </v-row>
                <v-row class="pt-5">
                  <v-btn
                    class="login-Btn"
                    @click="findId()"
                    :width="windowWidth > 500 ? 336 : 299"
                    >{{ idCheck ? "아이디 찾기" : "비밀번호 찾기" }}</v-btn
                  >
                </v-row>
              </div>
            </v-card>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserApi from "@/api/UserService";
import Mobile from "@/mixin/Mobile";
export default {
  props: ["idCheck"],
  mixins: [Mobile],

  data: () => ({
    name: "",
    phoneNumber: "",
    findState: false,
    returnDatas: "",
    id: "",
  }),
  computed: {
    text() {
      if (this.idCheck) {
        return `이름 및 전화번호를 입력하시면 \n 아이디를 확인 하실 수 있습니다.`;
      } else {
        return `이름 / 아이디 / 전화번호를 입력하시면 등록하신 전화번호를 통해 임시 비밀번호가 발송 됩니다.`;
      }
    },
  },

  methods: {
    async findId() {
      if (this.checkValue(this.phoneNumber, "전화번호를 입력해주세요.")) return;
      if (this.checkValue(this.name, "이름을 입력해주세요.")) return;
      if (this.checkValue(this.id, "아이디를 입력해주세요.") && !this.idCheck)
        return;
      let data = {
        phoneNumber: this.phoneNumber,
        userName: this.name,
        accountName: this.id,
      };
      let returnData;
      let text;
      if (this.idCheck) {
        returnData = await UserApi.userFindAccountName(data);
        if (returnData.data.success == "ok") {
          this.returnDatas = returnData.data.userName;
          text = `아이디는 ${this.returnDatas} 입니다.`;
        } else {
          text = "입력하신 등록정보에 해당하는 아이디가 없습니다.";
        }
      } else {
        returnData = await UserApi.userFindAccountPassword(data);
        if (returnData.data.success == "ok") {
          text = "등록된 전화번호로 임시 비밀번호가 발송되었습니다.";
        } else {
          text = "입력하신 등록정보가 일치 하지 않습니다.";
        }
      }
      this.$bus.$emit("dialog", text);
      if (returnData.data.success == "ok")
        this.$router.push({
          name: "Login",
        });
    },

    checkValue(value, text) {
      if (value == "") {
        this.$bus.$emit("dialog", text);
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.card {
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0px 4px 4px rgba(35, 62, 111, 0.3);
  border-radius: 15px;
  z-index: 1;
}

.pa-40 {
  padding: 40px;
}

.btn {
  color: white !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

h2 {
  color: white;
}

.width-height {
  width: 100%;
  height: 100%;
}

.row {
  margin: 0px !important;
}

.input {
  width: 336px;
  height: 46px;
  border-radius: 0px;
  border: 1px solid #ffffff33;
  color: white;
  padding-left: 12px;
}

.login-Btn {
  height: 62px !important;
  background: #68bae8 !important;
  color: white !important;
  font-style: Bold;
  font-size: 18px !important;
  border-radius: 100px !important;
  left: 0px;
  top: 0px;
}

.login {
  background-image: url(../../assets/login/login.svg);
  top: 0;
  left: 0;
  position: absolute;
  background-size: 100%;
  content: "";
  width: 100%;
  height: 100%;
}

.login-more {
  top: 0;
  left: 0;
  position: absolute;
  background-size: 100%;
  opacity: 0.8;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%),
    linear-gradient(0deg, #ffffff, #ffffff);
}

.login-more {
  height: 100%;
}

.login {
  height: 100%;
  position: relative;
  z-index: 1;
  border-radius: 30px !important;
}

.input::placeholder {
  color: white;
}
</style>
